import './index.less'

const List = {
  props:['data'],
  render(){
    const data = this.data || []
    return <div>
      {
        data.map(i => (
          <div class="item">
            <div class="item-hd">运单号：{i.waybillNo}</div>
            <div class="item-bd">
              <div>
                <span><Icon type="md-person" />{i.consignee}</span>
                <span><Icon type="ios-call" />{i.consigneeTel}</span>
              </div>
              <div><Icon custom="i-icon icon-location" />{i.consigneeAddr}</div>
            </div>
          </div>
        ))
      }
    </div>
  }
}
export default {
  props:['pointId'],
  data(){
    return {
      data:null,
      loading:false,
      visible:false
    }
  },
  created(){
    this.$watch('pointId' , function(nv){
      if( nv ) {
        this.visible = true
        this.query()
      }else{
        this.visible = false
      }
    },{immediate:true})
  },
  methods:{
    query(){
      this.loading = true
      this.$request.logisticsPathTask(this.pointId).then(resp => {
        this.loading = false
        this.data = resp.data
      })
    },
    handleClose(){
      this.visible = false
      this.$emit('close')
    }
  },
  render(){
    const data = this.data || {undone:{} , done:{}}

    return  <div class={{"route-view-panel":1 , active:this.visible}}>
        <div class="hd">
          <h3>{data.address || ''}</h3>
          <a on-click={this.handleClose}><Icon type="md-close" style={{fontSize:'16px'}} /></a>
        </div>
        <div class="bd">
          <Tabs value="t1" animated={false}>
            <TabPane label={'未完成  ' + data.undone.total} name="t1">
              <sl-spin loding={this.loading}><List data={data.undone.points} /></sl-spin>
            </TabPane>
            <TabPane label={'已完成  ' + data.done.total} name="t2">
              <sl-spin loding={this.loading}><List data={data.done.points} /></sl-spin>
            </TabPane>
          </Tabs>
        </div>
      </div>
  }
}